// The access token lives in this module only, never in a Web Storage: a script
// injected in the page (XSS) has nothing to read and replay elsewhere. A page
// load starts without it and gets one by a refresh, which the browser sends
// with the httponly refresh cookie (IETF "OAuth 2.0 for Browser-Based Apps").
type AccessTokenState = {
  accessToken: string
  // Epoch milliseconds, null when the issuer did not give a lifetime.
  expiresAt: number | null
};

let current: AccessTokenState | null = null;

export const accessTokenMemory = {
  getAccessToken: (): string | null => current?.accessToken ?? null,

  getExpiresAt: (): number | null => current?.expiresAt ?? null,

  setAccessToken(accessToken: string, expiresAt: number | null = null): void {
    current = { accessToken, expiresAt };
  },

  clear(): void {
    current = null;
  },
};

export const expiresAtFromLifetime = (expiresInSeconds?: number | null): number | null =>
  typeof expiresInSeconds === "number" && expiresInSeconds > 0 ? Date.now() + expiresInSeconds * 1000 : null;
